require('./src/zingchart-angularjs');
module.exports = 'zingchart-angularjs';



/*****************
 ** WEBPACK FOOTER
 ** ./~/zingchart-angularjs/index.js
 ** module id = 899
 ** module chunks = 8
 **/